/*
 * @Author: jiameng15
 * @Date: 2021-07-09 09:38:43
 * @Last Modified by: jiameng15
 * @Last Modified time: 2025-01-13 14:14:59
 * 用户相关接口
 */

import request from "@/utils/request"; // 引入request,基于axios
import queryString from "querystring"; // post方法传参转型String

export function getFunInfo(data) {
  return request({
    url: `/enjoyment-server/app/assessment/` + data.id,
    method: "get",
    data: data,
  });
}
export function getRecommend(data) {
  return request({
    url: `/enjoyment-server/app/assessment/` + data.id + `/recommendation`,  
    method: "get",
    data: data,
  });
}
export function getResult(data) {
  return request({
    url: `/enjoyment-server/app/user/answer/` + data.id + `/report`,
    method: "get",
    data: data,
  });
}
